import { useDispatch } from "react-redux";
import { useMutation } from "@tanstack/react-query"

import { deletePaciente } from "../services/pacienteheader.service";

import { successNotification, dangerNotification } from '../../../../../../redux/slices/ui';

export const usePacienteEliminar = () => {

    const dispatch = useDispatch();

    const eliminarPacienteMutation = useMutation({
        mutationFn: deletePaciente,
        onSuccess: (paciente, variables, context) => {
            dispatch(successNotification('Paciente eliminado'));
            variables.onSuccess();
        },
        onError: (error, variables, context) => {
            dispatch(dangerNotification(error.message));
            // dispatch(dangerNotification(error.msg.message));
        }
    });

    return {
        eliminarPacienteMutation,
    }
}